import type { State } from "../state/reducer";

import { serializeState } from "../state/reducer";
import { LocalStorageKeys, safeLocalStorage } from "@utilities/localStorage";

export const saveStateToSessionCookie = (state: State) => {
  const serializedState = serializeState(state);
  safeLocalStorage.setItem(LocalStorageKeys.SOUNDBOARD_STATE, JSON.stringify(serializedState));
};
